
export type BillStage =
  | 'intake'
  | 'extraction'
  | 'processing'
  | 'manual_review'
  | 'validation'
  | 'approval'
  | 'payment_ready'
  | 'archive';

export const STAGE_ORDER: BillStage[] = [
  'intake',
  'extraction',
  'processing',
  'manual_review',
  'validation',
  'approval',
  'payment_ready',
  'archive',
];

export const getNextStage = (current: BillStage): BillStage | null => {
  const idx = STAGE_ORDER.indexOf(current);
  if (idx === -1 || idx === STAGE_ORDER.length - 1) return null;
  return STAGE_ORDER[idx + 1];
};

export const isValidTransition = (from: BillStage, to: BillStage) => {
  const fromIdx = STAGE_ORDER.indexOf(from);
  const toIdx = STAGE_ORDER.indexOf(to);
  return fromIdx !== -1 && toIdx !== -1 && toIdx >= fromIdx; // allow forward or same-stage updates
};

export const timeInStageMs = (stageEnteredAt?: string | null) => {
  if (!stageEnteredAt) return 0;
  const entered = new Date(stageEnteredAt).getTime();
  return Math.max(0, Date.now() - entered);
};

export const isSlaBreached = (slaDueAt?: string | null) => {
  if (!slaDueAt) return false;
  return Date.now() > new Date(slaDueAt).getTime();
};

export const formatDuration = (ms: number) => {
  const sec = Math.floor(ms / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const d = Math.floor(hr / 24);
  if (d > 0) return `${d}d ${hr % 24}h`;
  if (hr > 0) return `${hr}h ${min % 60}m`;
  if (min > 0) return `${min}m`;
  return `${sec}s`;
};
